// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import Clear from './Clear'
import Create from './Create'
import Export from './Export'
import Search from './Search'

const buttonClasses = 'btn search-button big-button'

const ActionButtons = props => {
  const {
    clearForm,
    dbSet,
    exportResults,
    hasResults,
    idRoot,
    sourceForm,
  } = props

  return ([
    <Search
      key={'search-button'}
      idRoot={idRoot} />,
    <div
      key={'adv-button-wrapper'}
      className={'adv-db-search-buttons display-flex'}>
      <Clear
        clearForm={clearForm}
        idRoot={idRoot}
        sourceForm={sourceForm} />
      <Export
        buttonClasses={buttonClasses}
        exportResults={exportResults}
        hasResults={hasResults}
        idRoot={idRoot} />
    </div>,
    <Create
      key={'create-button'}
      buttonClasses={buttonClasses}
      dbSet={dbSet}
      idRoot={idRoot} />,
  ])
}

ActionButtons.propTypes = {
  clearForm: func,
  dbSet: string.isRequired,
  exportResults: func,
  hasResults: bool.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default ActionButtons

export Clear from './Clear'
export Search from './Search'
